<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-4/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
          <div class="rounded-t mb-0 px-12 py-6">
            <div class="text-center mb-3">
              <img alt="Gestión APA" class="mx-auto" :src="gestionApaLogo" />
            </div>
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">

            <div v-if="errors && !loading" class="text-white mb-6 px-6 py-4 border-0 rounded relative mb-4 bg-red-500">
              <span class="inline-block align-middle">
                {{ errors }}
              </span>
            </div>

            <form @submit="handleLogin">
              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Email
                </label>
                <input type="mail" v-model="form.mail"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Email" required />
              </div>

              <div class="relative w-full mb-3">
                <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                  Contraseña
                </label>
                <input type="password" v-model="form.password"
                  class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  placeholder="Contraseña" required />
              </div>

              <div class="text-center mt-10">
                <button
                  class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit" :disabled="loading">
                  Ingresar
                </button>
              </div>

              <!-- <div class="text-center mt-4">
                <a href="javascript:void(0)">
                  <small>Recuperar contraseña</small>
                </a>
              </div> -->
            </form>
          </div>
        </div>
        <div class="flex flex-wrap mt-6 relative justify-center">
          <small class="text-blueGray-200">v{{ version }}</small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gestionApaLogo from "@/assets/img/gestion-apa-logo.png";
import store from "@/store";

export default {
  name: "Login",

  data() {
    return {
      form: {
        mail: "",
        password: "",
      },
      errors: null,
      loading: false,
      gestionApaLogo,
      version: process.env.VUE_APP_VERSION
    };
  },

  methods: {
    handleLogin(event) {
      event.preventDefault();
      this.errors = null;
      this.loading = true;

      const languages = {
        'English': 'en',
        'Español': 'es'
      };

      const browserLanguage = navigator.language.split("-")[0]; // e.g., 'en-US' -> 'en'

      try {
        store.dispatch("auth/login", this.form).then(
          (response) => {
            this.$router.push("/");
            const currentLanguage = response.idioma ? languages[response.idioma] : null;
            this.$i18n.locale = currentLanguage || browserLanguage;
            console.log('login', response);
          },
          (error) => {
            this.loading = false;
            this.errors =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
      } catch (error) {
        this.loading = false;
        this.errors = error;
      }
    },
  }
};
</script>
